import type { PropsWithChildren, ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

import { AccordionItem } from 'components/Accordion/Item/AccordionItem';
import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { Icon } from 'components/Icon/Icon';
import type { IconName } from 'components/Icon/IconName';
import type { SearchRefinementType } from 'modules/search/constants/refinements/searchRefinementTypes';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';

import {
  SearchDateRangeAccordionSummary,
  SearchDateRangeAccordionSummaryLabel,
} from './SearchDateRangeAccordionItem.styled';

type Props = {
  facetType: SearchRefinementType;
  label: ReactNode;
  icon?: IconName;
};

export function SearchDateRangeAccordionItem({
  children,
  facetType,
  icon,
  label,
}: PropsWithChildren<Props>) {
  return (
    <AccordionItem
      name="search-facet"
      header={
        <SearchDateRangeAccordionSummary>
          <SearchDateRangeAccordionSummaryLabel>
            {icon ? <Icon size={18} name={icon} /> : undefined}
            <span>{label}</span>
          </SearchDateRangeAccordionSummaryLabel>
          <DropdownChevron size={16} />
        </SearchDateRangeAccordionSummary>
      }
    >
      <div data-facet-type={facetType}>
        {isValidElement<{ variant: SearchRefinementVariant }>(children)
          ? Children.only(cloneElement(children, { variant: 'accordion' }))
          : null}
      </div>
    </AccordionItem>
  );
}
